import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/rendez-vous',
    name: 'appointment',
    component: () => import('@/views/AppointmentView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/booking',
    name: 'booking',
    component: () => import('@/views/BookingView.vue')
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import('@/views/SignupView.vue')
  },
  {
    path: '/categorie',
    name: 'categorie',
    component: () => import('@/views/CategorieView.vue')
  },
  {
    path: '/services/:categorie',
    name: 'ServiceCategory',
    component: () => import('@/views/ServiceCategory.vue'),
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/userAccount',
    name: 'userAccount',
    component: () => import('@/views/UserAccount.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/reset-password/:token',
    name: 'ResetPassword',
    component: () => import('@/views/ResetPasswordRequest.vue'),
    props: true
  },
  {
    path: '/avancer-rdv',
    name: 'AvancerRdv',
    component: () => import('@/views/AvancerRdvView.vue')
  },
  {
    path: '/avis',
    name: 'Avis',
    component: () => import('@/views/AvisView.vue')
  },
  {
    path: '/legal/:type',
    name: 'Legal',
    component: () => import('@/views/LegalView.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 🛡️ Guard de navigation global pour vérifier l'authentification client
router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('clientToken')

    if (!token) {
      return next({ name: 'signup' })
    }

    try {
      const response = await fetch('https://natureletjoli-c64a9b4f6da0.herokuapp.com/api/clients/verify-token', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      if (!response.ok) {
        throw new Error('Token invalide')
      }

      next() // ✅ Token valide
    } catch (error) {
      console.error('Erreur de vérification de token :', error)
      localStorage.removeItem('clientToken') // 🧹 Nettoyage du token
      next({ name: 'signup' }) // 🔁 Redirection
    }
  } else {
    next() // ✅ Route publique
  }
})

export default router
